export const unitOrigin = 1
export const unitMaxAmount = 4
export const switchOrigin = 0
export const switchMaxAmount = 4
